export default __webpack_public_path__ + "static/1-1fde0839a993cfa3c285f7ec39c476ed.jpg";